package com.veldekar.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.browser.dom.ElementTarget
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment.CenterVertically
import com.varabyte.kobweb.compose.ui.Alignment.End
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.ariaHidden
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onAnimationEnd
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.CloseIcon
import com.varabyte.kobweb.silk.components.icons.HamburgerIcon
import com.varabyte.kobweb.silk.components.icons.IconRenderStyle
import com.varabyte.kobweb.silk.components.icons.MoonIcon
import com.varabyte.kobweb.silk.components.icons.SunIcon
import com.varabyte.kobweb.silk.components.icons.createIcon
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.overlay.AdvancedPopover
import com.varabyte.kobweb.silk.components.overlay.KeepPopupOpenStrategy
import com.varabyte.kobweb.silk.components.overlay.ManualOpenClosePopupStrategy
import com.varabyte.kobweb.silk.components.overlay.OpenClosePopupStrategy
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.overlay.OverlayVars
import com.varabyte.kobweb.silk.components.overlay.PopupPlacement.BottomRight
import com.varabyte.kobweb.silk.components.overlay.PopupPlacementStrategy
import com.varabyte.kobweb.silk.components.overlay.Tooltip
import com.varabyte.kobweb.silk.components.overlay.manual
import com.varabyte.kobweb.silk.components.overlay.never
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.veldekar.components.widgets.IconButton
import com.veldekar.model.NavPage
import com.veldekar.toSitePalette
import org.jetbrains.compose.web.css.AnimationDirection
import org.jetbrains.compose.web.css.AnimationFillMode
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Nav

private const val LOGO_WIDTH = 338
private const val LOGO_HEIGHT = 38

@Composable
private fun MoreVertIcon(modifier: Modifier = Modifier) {
    createIcon(renderStyle = IconRenderStyle.Fill(), attrs = modifier.toAttrs()) {
        Path {
            d(
                "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" +
                    "m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" +
                    "m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
            )
        }
    }
}

val NavHeaderStyle = CssStyle.base {
    Modifier.fillMaxWidth().padding(leftRight = 1.cssRem, topBottom = 0.5.cssRem).zIndex(50)
}

@Composable
private fun NavLink(path: String, text: String, isActive: Boolean, onClick: (() -> Unit)? = null) {
    val activeModifier = if (isActive) {
        Modifier
            .fontWeight(com.varabyte.kobweb.compose.css.FontWeight.Bold)
            .color(ColorMode.current.toSitePalette().brand.primary)
    } else Modifier

    Link(
        path,
        text,
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
        modifier = activeModifier.then(onClick?.let { Modifier.onClick { onClick() } } ?: Modifier)
    )
}

@Composable
private fun MenuItems(pages: List<NavPage>, currentPath: String, onClick: (() -> Unit)? = null) {
    pages.forEach { page ->
        NavLink(page.path, page.title, isActive = currentPath == page.path, onClick)
    }
}

@Composable
private fun PrimaryMenuItems(currentPath: String = "", onClick: (() -> Unit)? = null) {
    val pages = NavPage.primary().let { if (currentPath == "/") it.filter { p -> p != NavPage.HOME } else it }
    MenuItems(pages, currentPath, onClick)
}

@Composable
private fun SecondaryMenuItems(currentPath: String = "", onClick: (() -> Unit)? = null) {
    MenuItems(NavPage.secondary(), currentPath, onClick)
}

@Composable
private fun AllMenuItems(currentPath: String = "", onClick: (() -> Unit)? = null) {
    val pages = NavPage.all().let { if (currentPath == "/") it.filter { p -> p != NavPage.HOME } else it }
    MenuItems(pages, currentPath, onClick)
}

val MoreMenuPopoverStyle = CssStyle.base {
    Modifier
        .backgroundColor(colorMode.toSitePalette().nearBackground)
        .borderRadius(0.5.cssRem)
        .padding(0.75.cssRem)
        .boxShadow(offsetX = 0.px, offsetY = 2.px, blurRadius = 8.px, color = Colors.Black.copyf(alpha = 0.15f))
        .zIndex(200)
}

@Composable
private fun MoreMenuButton(currentPath: String = "") {
    val openCloseStrategy: ManualOpenClosePopupStrategy = remember { OpenClosePopupStrategy.manual() }
    val placementStrategy = remember { PopupPlacementStrategy.of(BottomRight) }

    IconButton(onClick = { openCloseStrategy.isOpen = !openCloseStrategy.isOpen }, ariaLabel = "Open menu") {
        MoreVertIcon(Modifier.ariaHidden(true))
    }
    if (openCloseStrategy.isOpen) {
        Overlay(
            Modifier
                .setVariable(OverlayVars.BackgroundColor, Colors.Transparent)
                .onClick { openCloseStrategy.isOpen = false }
        )
    }
    AdvancedPopover(
        target = ElementTarget.PreviousSibling,
        modifier = MoreMenuPopoverStyle.toModifier(),
        openCloseStrategy = openCloseStrategy,
        placementStrategy = placementStrategy,
        keepOpenStrategy = KeepPopupOpenStrategy.never()
    ) {
        Column(Modifier.gap(0.75.cssRem)) {
            SecondaryMenuItems(currentPath = currentPath, onClick = { openCloseStrategy.isOpen = false })
        }
    }
}

@Composable
private fun ColorModeButton() {
    var colorMode by ColorMode.currentState
    IconButton(onClick = { colorMode = colorMode.opposite }, ariaLabel = "Toggle color mode") {
        if (colorMode.isLight) MoonIcon(Modifier.ariaHidden(true)) else SunIcon(Modifier.ariaHidden(true))
    }
    Tooltip(ElementTarget.PreviousSibling, "Toggle color mode", modifier = Modifier.displayIfAtLeast(MD), placement = BottomRight)
}

@Composable
private fun HamburgerButton(onClick: () -> Unit) {
    IconButton(onClick, ariaLabel = "Open navigation menu") {
        HamburgerIcon(Modifier.ariaHidden(true))
    }
}

@Composable
private fun CloseButton(onClick: () -> Unit) {
    IconButton(onClick, ariaLabel = "Close menu") {
        CloseIcon(Modifier.ariaHidden(true))
    }
}

val SideMenuSlideInAnim = Keyframes {
    from {
        Modifier.translateX(100.percent)
    }

    to {
        Modifier
    }
}

// Note: When the user closes the side menu, we don't immediately stop rendering it (at which point it would disappear
// abruptly). Instead, we start animating it out and only stop rendering it when the animation is complete.
enum class SideMenuState {
    CLOSED,
    OPEN,
    CLOSING;

    fun close() = when (this) {
        CLOSED -> CLOSED
        OPEN -> CLOSING
        CLOSING -> CLOSING
    }
}

@Composable
fun NavHeader(currentPath: String = "") {
    Nav(Modifier.fillMaxWidth().toAttrs()) {
        Row(NavHeaderStyle.toModifier(), verticalAlignment = CenterVertically) {
            Link("/", modifier = Modifier.minWidth(0.px)) {
                // Block display overrides inline display of the <img> tag, so it calculates centering better
                // maxHeight instead of height keeps height:auto so the image scales proportionally when
                // maxWidth(100%) shrinks it on narrow screens, preventing horizontal overflow.
                Image(
                    src = "/veldekarLogo.webp",
                    description = "Veldekar Logo",
                    width = LOGO_WIDTH,
                    height = LOGO_HEIGHT,
                    modifier = Modifier.width(auto).height(auto).maxHeight(1.2.cssRem).maxWidth(100.percent).display(DisplayStyle.Block)
                )
            }

            Spacer()

            Row(Modifier.gap(1.5.cssRem).displayIfAtLeast(MD), verticalAlignment = CenterVertically) {
                PrimaryMenuItems(currentPath)
                MoreMenuButton(currentPath)
                ColorModeButton()
            }

            Row(
                Modifier
                    .fontSize(1.5.cssRem)
                    .gap(1.cssRem)
                    .displayUntil(MD),
                verticalAlignment = CenterVertically
            ) {
                var menuState by remember { mutableStateOf(SideMenuState.CLOSED) }

                ColorModeButton()
                HamburgerButton(onClick = { menuState = SideMenuState.OPEN })

                if (menuState != SideMenuState.CLOSED) {
                    SideMenu(
                        menuState,
                        currentPath,
                        close = { menuState = menuState.close() },
                        onAnimationEnd = { if (menuState == SideMenuState.CLOSING) menuState = SideMenuState.CLOSED }
                    )
                }
            }
        }
    }
}

@Composable
private fun SideMenu(
    menuState: SideMenuState,
    currentPath: String = "",
    close: () -> Unit,
    onAnimationEnd: () -> Unit
) {
    Overlay(
        Modifier
            .setVariable(OverlayVars.BackgroundColor, Colors.Transparent)
            .onClick { close() }
            .zIndex(200)
    ) {
        key(menuState) { // Force recompute animation parameters when close button is clicked
            Column(
                Modifier
                    .fillMaxHeight()
                    .width(clamp(12.cssRem, 40.percent, 14.cssRem))
                    .align(CenterEnd)
                    // Close button will appear roughly over the hamburger button, so the user can close
                    // things without moving their finger / cursor much.
                    .padding(top = 1.cssRem, leftRight = 1.cssRem)
                    .gap(1.5.cssRem)
                    .backgroundColor(ColorMode.current.toSitePalette().nearBackground)
                    .animation(
                        SideMenuSlideInAnim.toAnimation(
                            duration = 200.ms,
                            timingFunction = if (menuState == SideMenuState.OPEN) AnimationTimingFunction.EaseOut else AnimationTimingFunction.EaseIn,
                            direction = if (menuState == SideMenuState.OPEN) AnimationDirection.Normal else AnimationDirection.Reverse,
                            fillMode = AnimationFillMode.Forwards
                        )
                    )
                    .borderRadius(topLeft = 2.cssRem)
                    .onClick { it.stopPropagation() }
                    .onAnimationEnd { onAnimationEnd() }
                    .zIndex(200),
                horizontalAlignment = End
            ) {
                CloseButton(onClick = { close() })
                Column(
                    Modifier.padding(right = 0.75.cssRem).gap(1.5.cssRem).fontSize(1.4.cssRem).textAlign(TextAlign.End),
                    horizontalAlignment = End
                ) {
                    AllMenuItems(currentPath, onClick = { close() })
                }
            }
        }
    }
}
